import { convertDensityFromKgPerLToLbsPerGal } from './convertDensity';

export const handleMasterProduct = setSchema => {
  setSchema('MASTER');
};

export const handleServiceProduct = (product, setCustomProduct, setSchema) => {
  setCustomProduct(product);
  setSchema('SERVICE');
};

export const handleFertilizerProduct = (
  product,
  setCustomProduct,
  setSchema,
  fetchCustomProduct,
  visible
) => {
  setCustomProduct(product);
  setSchema('FERTILIZER');

  if (visible && !product.isNew) {
    fetchCustomProduct(product.productId).then(res => {
      setCustomProduct({
        ...res.data,
        // The detail response can omit Make-Up; fall back to the value the
        // user already had so it is retained on edit.
        makeUp: res?.data?.makeUp ?? product.makeUp,
        averagePricePerUnit: product.averagePricePerUnit,
        averagePricePerUnitUnit: product.averagePricePerUnitUnit,
        custom: true,
        densityInLbsPerGallon: convertDensityFromKgPerLToLbsPerGal(
          product?.density
        )
      });
    });
  }
};
